import { render, staticRenderFns } from "./CreateEntity.vue?vue&type=template&id=24fa79e5&"
import script from "./CreateEntity.vue?vue&type=script&lang=js&"
export * from "./CreateEntity.vue?vue&type=script&lang=js&"
import style0 from "./CreateEntity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports